import { render, staticRenderFns } from "./AyudaCargaSmolt.vue?vue&type=template&id=9ef3b89a&scoped=true"
import script from "./AyudaCargaSmolt.vue?vue&type=script&lang=js"
export * from "./AyudaCargaSmolt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef3b89a",
  null
  
)

export default component.exports